/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Admin_Only_HintInputs */



/**
* | output |
* | --- |
* | "Only project admins can change this." |
*
* @param {Project_Private_Chats_Admin_Only_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_admin_only_hint = /** @type {((inputs?: Project_Private_Chats_Admin_Only_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Admin_Only_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Projekt-Admins können das ändern.")
	return /** @type {LocalizedString} */ ("Only project admins can change this.")
});